import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=034e2bd6&"
import script from "./Tokens.vue?vue&type=script&lang=js&"
export * from "./Tokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports